module.exports = __webpack_public_path__ + "static/media/netflix (1).9bc15477.png";